module.exports = __webpack_public_path__ + "img/faqs_cold_weather_tips.accc281a.webp";